function test_ready(fn){
    if(document.addEventListener){
            document.addEventListener('DOMContentLoaded',function(){
                document.removeEventListener('DOMContentLoaded',arguments.callee,false);
                fn();
            },false);
     }else if(document.attachEvent){
          document.attachEvent('onreadystatechange',function(){
               if(document.readyState=='complete'){
                    document.detachEvent('onreadystatechange',arguments.callee);
                    fn();
               }
          });
    }
}
  test_ready(() => {            
		const tabsRoot = document.querySelector('.product-description[data-product-description]');
		const stickyTabs = document.querySelector('.product-description .product-tabs-sticky');
		const siteHeader = document.querySelector('[data-site-header]');
		if (stickyTabs && siteHeader) {
			const updateStickyTabsTop = () => {
				stickyTabs.style.setProperty('--product-tabs-sticky-top', `${Math.ceil(siteHeader.getBoundingClientRect().height)}px`);
			};
			updateStickyTabsTop();
			window.addEventListener('resize', updateStickyTabsTop);
			window.addEventListener('scroll', updateStickyTabsTop, { passive: true });
		}

		if (tabsRoot) {
			tabsRoot.querySelectorAll('.tabs li').forEach(tab => {
				tab.addEventListener('click', () => {
					const targetClass = tab.dataset.tab;
					if (!targetClass) return;
					tabsRoot.querySelectorAll('.tabs li').forEach(item => item.classList.remove('active'));
					tabsRoot.querySelectorAll('.tabs-content-item').forEach(item => item.classList.remove('active'));
					tab.classList.add('active');
					const target = tabsRoot.querySelector('.' + targetClass);
					if (target) target.classList.add('active');
					tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
				});
			});
		}
	
  }); 

  // 产品主图下的促销倒计时
  document.addEventListener('DOMContentLoaded', function() {
    if($("#promotion_clock")){
      var d, h, m, s;
      // 1.设置结束时间
      let endDate = new Date('2026/01/05 16:00:00');

      function updateCountdown() {
          const now = new Date();

          // 3.将用户访问时间统一为UTC+8
          now.setUTCHours(now.getUTCHours() + (now.getTimezoneOffset() + 8 * 60) / 60);

          // 5.获取时间差 = 结束时间戳 - 开始时间戳
          let startTime = now.getTime()
          let endTime = endDate.getTime()

          // 6. 将时间差转换为小时、分钟和秒
          if (endTime >= startTime) {
              timeArr(endTime - startTime)
              function checkTime(i){
                  if (i<10) {
                      i = "0"+i;
                  }
                  return i;
              }
              document.getElementById("promotion_clock").innerHTML = `${checkTime(d)} : ${checkTime(h)} : ${checkTime(m)} : ${checkTime(s)}`;
          }
      }
      function timeArr(timeLeft){
          d = Math.floor(timeLeft/1000/60/60/24);
          h = Math.floor(timeLeft/1000/60/60%24);
          m = Math.floor(timeLeft/1000/60%60);
          s = Math.floor(timeLeft/1000%60);
      }

      setInterval(updateCountdown, 1000);
    }
  });

// Ensure product gallery thumbnails are visible if theme JS fails to remove .loading
function revealProductGalleryThumbnails() {
  document.querySelectorAll('[data-gallery-navigation].loading').forEach(function(nav) {
    nav.classList.remove('loading');
  });
}

if (document.querySelector('[data-product-gallery]')) {
  revealProductGalleryThumbnails();
  document.addEventListener('DOMContentLoaded', revealProductGalleryThumbnails);
  window.addEventListener('load', revealProductGalleryThumbnails);
  setTimeout(revealProductGalleryThumbnails, 1500);
}

// product highlights
window.onload = function() {
  if(window.screen.width > 1024){
    if($(".product-gallery--image").length>0){
      $(".product__container .product-gallery .product-highlights").show()
    }
  }else{
      $(".product__container .product-main .product-highlights").show()
  }
};
